













































import { Component, Mixins, Prop, Emit } from 'vue-property-decorator';
import BurgerMenu from './burger-menu/BurgerMenu.vue';
import BaseMixin from '@/mixins/BaseMixin';
import Navigation from './Navigation.vue';
import { SubMenuItem } from '@/entities/navigation/SubMenuItem';

@Component({
    components: {
        BurgerMenu,
    },
})
export default class NavigationItem extends Mixins(BaseMixin) {
    @Prop(String)
    private link!: string;

    @Prop(String)
    private title!: string;

    @Prop(Boolean)
    private isFixed!: boolean;

    @Prop(Boolean)
    private isActive!: boolean;

    @Prop({ required: false })
    private subMenuItemsJson!: string;

    private subMenuItems: SubMenuItem[] = [];

    private expandSubItems: boolean = false;

    private get getHrefLink(): string {
        return this.link.startsWith('#') ? '#' : this.link;
    }

    private get hasSubMenuItemsLevel1(): boolean {
        return this.subMenuItems.length > 0;
    }

    public mounted(): void {
        if (this.subMenuItemsJson) {
            this.subMenuItems = JSON.parse(this.subMenuItemsJson);
        }
    }

    private toggleExpandSubItems(): void {
        this.expandSubItems = !this.expandSubItems;
    }

    private onMouseOver(): void {
        // we cannot emit events, because this naviTems are added via <slot>.
        // therefore we have to go the way over $parent.
        const parent = this.$parent as Navigation;
        if (parent) {
            parent.onMouseOverItem(this.link);
        }
    }
}
